import React, { ChangeEvent } from "react";
import classes from "./SelectBox.module.scss";
import arrowup from "../../static/images/ArrowUp.svg";
type SelectBoxProps = {
  id: string;
  label?: string;
  title: SelectBoxTitle;
  defaultValue?: string;
  selectWidth?: string; 
  option: SelectBoxOption[];
  onChange: (args: SelectBoxOption) => void;
  hideNone?: true;
  caption?: string;
  vertical?: true;
  suffix?: string;
};

export type SelectBoxOption = { name: string; value: string };
export type SelectBoxTitle = { name?: string; value: string };

const SelectBox = (props: SelectBoxProps) => {
  const onChange = (e: ChangeEvent<HTMLSelectElement>, name: string) => {
    props.onChange({ name, value: e.target.value });
  };

  return (
    <div className={classes.container}>
      <label className={classes.label}>{props.label}</label>

      <div
        className={classes.selectAreaContainer}
        style={props.vertical ? { flexDirection: "column", alignItems: "start" } : undefined}
      >
        <div style={props.vertical ? { marginBottom: "12rem", fontWeight: "400" } : undefined}>
          {props.title?.name}
          {props.caption && <div className={classes.caption}>{props.caption}</div>}
        </div>

        <div
          className={classes.selectRow}
          style={props.selectWidth ? { width: props.selectWidth } : undefined}
        >
          <select
            value={props.defaultValue ?? "NA"}
            className={classes.select}
            onChange={(e) => onChange(e, props.title?.value)}
          >
            {!props.hideNone && <option value="NA">選択してください</option>}
            {props.option.map((option, index) => (
              <option key={props.id + "-" + index} value={option.value}>
                {option.name}
              </option>
            ))}
          </select>
          {props.suffix && <span className={classes.suffix}>{props.suffix}</span>}
        </div>
      </div>
    </div>
  );
};

export default SelectBox;
